module.exports = __webpack_public_path__ + "img/home-sm.af56a68d.jpg";